import { AdminEditMenuItemScreen } from '@/features/admin/screens/admin-edit-menu-item-screen';

export default function AdminEditMenuItemRoute() {
  return <AdminEditMenuItemScreen />;
}
